<template>
  <router-view></router-view>
</template>

<script type="text/javascript">
import MainHeader   from './components/layout/MainHeader';
import {mapGetters} from 'vuex'
import axios    from '@/services/axios';
export default {
  name: 'App',
  data() {
    return {
      message: "",
      msgStyle: "info",
      links: [
        { icon: 'accessibility', name: 'Workouts', path: '/workouts' },
        { icon: 'cogs', name: 'Settings', path: '/settings' }
      ]
    }
  },
  components: {
    MainHeader
  },
  computed: {
    ...mapGetters({
      currentUser:    'currentUser',
      activeWorkout:  'activeWorkout',
      messages:       'getMessages'
    }),
    light() {
      let that = true
      if (this.currentUser) {
        that = this.currentUser.app_style === 'light'
      }
      return that
    },
    dark() {
      let that = false
      if (this.currentUser) {
        that = this.currentUser.app_style === 'dark'
      }
      return that
    },
    
  },
  created () {
    this.checkCurrentLogin()
  },
  activated(){
    this.checkCurrentLogin()
  },
  updated () {
    this.checkCurrentLogin()
  },
  methods: {
    appStyle() {
      let style = 'light'
      if (this.currentUser) {
        style = this.currentUser.app_style || 'light'
      }
      return style + 'App'
    },
    checkCurrentLogin () {
      let loginRoute = "/login";
      if (!this.currentUser && this.$route.path !== loginRoute) {
        let toPath = loginRoute;
        if (this.$route.path !== "/logout" && this.$route.path !== "/" && this.$route.path !== "") {
          toPath += '?redirect=' + this.$route.path
        }
        this.$router.push(toPath)
      } else {
        // test call to API, to check authentication
        axios.get("/check").then((response) => {
          console.log("DEBUG  |  checkCurrentLogin: ", response)
        }).catch((error) => {
          console.log("DEBUG  |  checkCurrentLogin - ERROR!: ", error)
        });
      }
    },
    showMSG( msg, style = 'info' ) {
      console.log("showMSG", msg, style)
      this.message  = msg
      this.msgStyle = style
    },
    removeMSG() {
      this.message  = ''
    },
    
    removeMessage(msg) {
      console.log("removeMessage c", msg)
      this.$store.dispatch('removeMessage', msg)
    },
    
    getTypeStyle( type ) {
      if (type === 'alert' || type === 'danger' || type === "error") {
        return "alert-danger"
      } else {
        return "alert-info"
      }
    },
    removeAllMessages() {
      this.$store.dispatch('removeAllMessages')
    }
  }
};

</script>

<style lang="scss">

// @import 'vuetify/dist/vuetify.min.css';
@import './assets/scss/main.scss';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}


#messagesBox {
  display: block;
  position: fixed;
  top: 70px;
  left: 20px; right: 20px;
  background: transparent;
  z-index: 9999;
  .msg {
    font-weight: 500;
    font-size: 120%;
    background: #fff;
    padding: 10px 30px;
    border: solid 1px #ccc;
    border-radius: 3px;
    margin: 0 0 10px;
    &.error, &.alert {
      border-color: #c00;
      background: #EED6D7;
    }
  }
}


.slide-enter {}
.slide-enter-active {
  animation: slide-in .5s ease-out forwards;
}
.slide-leave {}
.slide-leave-active {
  animation: slide-out 1s ease-out forwards;
  position: absolute;
  left: 15px;
  right: 15px;
}
.slide-move {
  transition: transform 1s;
}

@keyframes slide-in {
  from {
    transform: translateY(100px) scale(0.5);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1.0);
    opacity: 1.0;
  }
}
@keyframes slide-out {
  from {
    /* transform: translateY(0); */
    transform: translateY(0) scale(1.0);
    opacity: 1.0;
  }
  to {
    /* transform: translateY(20px); */
    transform: translateY(100px) scale(0.5);
    opacity: 0;
  }
}
</style>
